import $ from 'jquery';
import {forOwn} from '../../../lib/utilities';

const NO_GROWTH = -1;
const NEGATIVE_GROWTH = 1;
const POSITIVE_GROWTH = 1;

class ResizeHandlerClass {
    constructor() {
        this.callbacks = {};
        this.subscribeCount = 0;
        this.oldViewportWidth = window.innerWidth;
        this.oldViewportHeight = window.innerHeight;

        this.handleResize();
    }

    subscribe(callback) {
        const unsubscribeToken = this.subscribeCount++;
        this.callbacks[unsubscribeToken] = callback;

        return () => {
            return delete this.callbacks[unsubscribeToken];
        };
    }

    handleResize() {
        $(window).on('resize', () => {
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            let widthGrowth = NO_GROWTH;
            if (viewportWidth !== this.oldViewportWidth) {
                widthGrowth = viewportWidth > this.oldViewportWidth ? POSITIVE_GROWTH : NEGATIVE_GROWTH;
            }

            let heightGrowth = NO_GROWTH;
            if (viewportHeight !== this.oldViewportHeight) {
                heightGrowth = viewportHeight > this.oldViewportHeight ? POSITIVE_GROWTH : NEGATIVE_GROWTH;
            }

            forOwn(this.callbacks, callback => callback({
                viewportWidth,
                viewportHeight,
                widthGrowth,
                heightGrowth,
            }));

            this.oldViewportWidth = window.windowWidth;
            this.oldViewportHeight = window.windowHeight;
        });
    }
}

const ResizeHandler = new ResizeHandlerClass();

export {
    ResizeHandler,
    NO_GROWTH,
    NEGATIVE_GROWTH,
    POSITIVE_GROWTH
};